<template>
  <div>

    <div class="row">
      <div class="col-md-12">
                <PageHeader icon="fas fa-user-plus">
          <template #title>
            Tambah Pasien
          </template>
          <template #subtitle>
            Masukkan data personal, kontak, dan informasi medis pasien baru
          </template>
        </PageHeader>

        <Form
          :form="form"
          :route="'patients'"
          purpose="master"
          :password='true'
          :show-bpjs-registration="true"
        />
      </div>
    </div>

  </div>
</template>

<script>

import Form from '@/component/patients/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  name: 'Add',

  data() {
    return {
      form: {
        email: "",
        name: "",
        patient_id: "",
        birt_place: "",
        birt_date: "",
        address: "",
        gender: "",
        phone: "",
        mobile_phone: "",
        parent_name: "",
        blood_type: "",
        id_card_number: "",
        allergy: "",
        password: "",
        password_confirmation: "",
        status: "",
        title: "",
        doctor_in_charge: [],
        responsible_doctor: [],
        photo: [],
        photo_name: s3Endpoint + "/assets/public/default-profile.svg",
        photo_default: "/assets/public/default-profile.svg",
        notes:"",
        ss_patient_id:"",
        country_id:74,
        isResetImg: false,
        province_id:null,
        capital_id:null,
        subdistrict_id:null,
        village_id:null,
        coverage_type:"umum",
        bpjs_card_number:"",
        bpjs_participant_status:"",
        bpjs_verified_at:"",
        bpjs_fktp_code:"",
        bpjs_fktp_name:"",
      }
    }
  },

  components: {
    Form
  },

  methods: {

  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pasien", route: "" },
      { title: "Daftar Pasien", route: "/patient/list" },
      { title: "Tambah" },
    ])
  },

}

</script>
